// extracted by mini-css-extract-plugin
module.exports = {"contentHub":"Sentiment_contentHub__7OFLh"};